import React from 'react'
import { GET_ADDRESS_FROM_POSTAL_CODE, GET_ADDRESS_FROM_POSTAL_CODE_FAILED, GET_ADDRESS_FROM_POSTAL_CODE_SUCCESS } from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { GETAddressFromPostalCodeSupportResponse, getAddressFromPostalCodeSupportRequest } from '@cbgms/api'
import { getLocation } from 'app-support/shops/state/actions'
import { useDispatch } from 'react-redux'
import { AddressSearchAutocomplete, AddressSearchByIdAutocomplete, AddressSearchResolve } from '../state/region/actions'
import { CountriesOptionsWrapper } from 'core/widgets/CountriesDropdown/countryOptionsWrapper'
import { AddressProps } from '@cbgms/components/form/address/types'
import { Address } from '@cbgms/components/form/address/Address'

const getAddressFromPostalCode = (CountryCode: string, HouseNumber: string, PostalCode: string) =>
  AsyncAction<GETAddressFromPostalCodeSupportResponse>({
    type: [GET_ADDRESS_FROM_POSTAL_CODE, GET_ADDRESS_FROM_POSTAL_CODE_SUCCESS, GET_ADDRESS_FROM_POSTAL_CODE_FAILED],
    payload: getAddressFromPostalCodeSupportRequest(CountryCode, HouseNumber, PostalCode)
  })

type GmsAddressProps = Omit<AddressProps, 'getAddressFromPostalCode' | 'getLocationFromAddress' | 'actions' | 'countryOptions'>

const SupportAddress: React.FC<GmsAddressProps> = props => {
  const dispatch = useDispatch()

  const getLocationFromAddress: AddressProps['getLocationFromAddress'] = async params => {
    const result = await dispatch(
      getLocation({
        ...params,
        ResolveCoordinatesOnly: true
      })
    )
    return result.Data.Coordinates
  }

  return (
    <CountriesOptionsWrapper>
      {options => (
        <Address
          {...props}
          countryOptions={options}
          getAddressFromPostalCode={getAddressFromPostalCode}
          getLocationFromAddress={getLocationFromAddress}
          actions={{ AddressSearchAutocomplete, AddressSearchByIdAutocomplete, AddressSearchResolve }}
        />
      )}
    </CountriesOptionsWrapper>
  )
}

SupportAddress.displayName = 'SupportAddress'
export default SupportAddress
